import React, { useMemo, useState } from 'react';
import {
  Card,
  Row,
  Col,
  DatePicker,
  Spin,
  Divider,
  notification,
  Input,
} from 'antd';
import DF from 'DisplayFramework';
import FormInput from 'components/FormInput';
import { Form } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import {
  dateToString,
  shouldUpdateCompare,
  toDatePickerDate,
} from 'utils/utils2';
import Button from 'components/Button';
import Title from 'components/Title';
import ProposalSelect from 'components/ProposalSelect';
import UtinaCard from 'components/UtinaCard';
import ProductInput from './PropDetail/ProductInput';
import JobResult from 'pages/Accounting/Components/JobResult';
import {
  runExtendContractElements,
  runExtendContractElementsParams,
} from 'services/fincontract';
import { useQuery } from 'react-query';

const initialSearchParams: any = {
  ctridstart: 0,
  ctridend: 10000000,
  enddate: '',
  prcode: '',
  months_to_extend: 0,
  jobid: 0,
};

const ExtendLongTermRental = () => {
  const [form] = useForm();

  const [searchParams, setSearchParams] =
    useState<runExtendContractElementsParams>(initialSearchParams);

  const [productcode, setProductcode] = useState('');

  const onFinish = (values: runExtendContractElementsParams) => {
    setSearchParams((prev) => ({
      ...prev,
      ...values,
      ctridend: form.getFieldValue('ctridend').ctrid ?? 10000000,
    }));
    setTimeout(refetch, 0);
  };

  const params = useMemo(
    () => ({ ...searchParams, enddate: dateToString(searchParams.enddate) }),
    [searchParams]
  );

  const {
    data: jobResponse,
    refetch,
    isFetching,
  } = useQuery(
    ['runExtendContractElements', params],
    () =>
      runExtendContractElements(params).then((res) => {
        notification.info({
          message: res.message,
          placement: 'bottomRight',
        });
        return res;
      }),
    {
      enabled: false,
    }
  );

  const [disabled, setDisabled] = useState(false);

  return (
    <DF.Provider pagcode="extendlongtermrental">
      <Spin spinning={false}>
        <Card
          title={<Title level={4} comcode="extendterm"></Title>}
          size="small"
        >
          <Form form={form} onFinish={onFinish} layout="vertical">
            <Row>
              <Col md={24}>
                <Row gutter={10}>
                  <Col md={20}>
                    <UtinaCard lg={19} comcode="extendterm" level={5}>
                      <Row gutter={10}>
                        <FormInput col xs={24} md={8} lg={8} name="prcode">
                          <ProductInput
                            onChange={(e) => {
                              setProductcode(e);
                            }}
                          />
                        </FormInput>
                        <FormInput
                          col
                          xs={24}
                          md={8}
                          lg={8}
                          name="ctridstart"
                          shouldUpdate={shouldUpdateCompare('ctridstart')}
                        >
                          <ProposalSelect
                            onlyctrid
                            phase=""
                            PropOrProd="PROD"
                            onSelected={(e: any) => {
                              form.setFieldsValue({
                                ctridend: e,
                                enddate: toDatePickerDate(e.values.cteenddate),
                              });
                            }}
                            prcode={productcode}
                          />
                        </FormInput>
                        <FormInput
                          col
                          xs={24}
                          md={8}
                          lg={8}
                          name="ctridend"
                        >
                          <ProposalSelect
                            onlyctrid
                            phase=""
                            PropOrProd="PROD"
                            onSelected={(e: any) => {
                              form.setFieldsValue({ ctridend: e });
                            }}
                          />
                        </FormInput>
                        <FormInput
                          col
                          xs={24}
                          md={8}
                          lg={8}
                          name="enddate"
                          shouldUpdate
                        >
                          <DatePicker showToday />
                        </FormInput>
                        <FormInput
                          col
                          xs={24}
                          md={8}
                          lg={8}
                          name="months_to_extend"
                        >
                          <Input />
                        </FormInput>
                      </Row>
                    </UtinaCard>
                  </Col>

                  <Col
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <Button
                      loading={false}
                      comcode="runservice"
                      type="primary"
                      htmlType="submit"
                      style={{ width: 200, marginLeft: 15, height: 60 }}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row>
              <Col style={{ alignContent: 'center' }} xs={24}>
                {false && (
                  <Title level={3} type="danger" comcode="pleasewait" />
                )}
              </Col>
            </Row>
          </Form>
          <Divider></Divider>
          <UtinaCard comcode="result" level={5}>
            {false && <JobResult jobResponse={jobResponse} />}
          </UtinaCard>
        </Card>
      </Spin>
    </DF.Provider>
  );
};

export default ExtendLongTermRental;
